import { render, staticRenderFns } from "./users.vue?vue&type=template&id=4eef7fb9&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eef7fb9",
  null
  
)

export default component.exports